import { getUrl } from '../config';
import { createContext, useEffect, useReducer } from "react";

import axios from 'axios';
import { isValidToken, setSession } from "../utils/jwt";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// Note: If you're trying to connect JWT to your own backend, don't forget
// to remove the Axios mocks in the `/src/index.js` file.

const INITIALIZE = "INITIALIZE";
const SIGN_IN = "SIGN_IN";
const SIGN_OUT = "SIGN_OUT";
const SIGN_UP = "SIGN_UP";

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  group: null,
};

const JWTReducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
        group: action.payload.group,

      };
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        group: action.payload.group,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        group: null,
      };

    case SIGN_UP:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        group: action.payload.group,
      };

    default:
      return state;
  }
};

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(JWTReducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          const response = await axios.get(getUrl() + "/api/auth/account");
          const { user, group } = response.data;
          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: true,
              user,
              group,
            },
          });
        } else {
          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
              group: null,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
            group: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const navigate = useNavigate();

  const { i18n } = useTranslation();

  const signIn = async (username, password) => {
    const response = await axios.post(getUrl() + "/api/auth/login", {
      username,
      password,
    });
    const { token, user, group } = response.data;
    setSession(token);
    window.localStorage.setItem("userId", user.id);
    dispatch({
      type: SIGN_IN,
      payload: {
        user,
        group,
      },
    });
    if (user.language == 0) {
      i18n.changeLanguage("en");
    } else if (user.language == 1) {
      i18n.changeLanguage("fr");
    }
    navigate('/');
  };

  const signOut = async () => {
    setSession(null);
    dispatch({ type: SIGN_OUT });
  };

  const signUp = async (email, password, firstName, lastName) => {
    const response = await axios.post("/api/auth/sign-up", {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem("accessToken", accessToken);
    window.localStorage.setItem("userId", user.id);

    dispatch({
      type: SIGN_UP,
      payload: {
        user,
      },
    });
  };


  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        signIn,
        signOut,
        signUp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
